import React from 'react'
import { useNavigate } from 'react-router-dom';
import { meditation } from '../../routes/route';
const { MEDITATION_CATEGORY_LIST, MEDITATION_DASHBOARD } = meditation;
const Meditation = () => {
  const navigate = useNavigate();
    return (
        <div className="container min-vh-100 d-flex justify-content-center align-items-center">
          <div className="row text-center">
            <div className="col-12 mb-4">
              <h1 className="display-4">Meditation Management</h1>
              <p className="lead">Choose an option to proceed</p>
            </div>
            <div className="col-md-6 mb-3 block_user_button">
              <button 
                className="btn-lg w-100 py-3" 
                onClick={() => navigate(MEDITATION_CATEGORY_LIST)}
              >
                Manage Medication
              </button>
            </div>
            <div className="col-md-6 mb-3">
              <button 
                className="btn btn-secondary btn_secondary_btn btn-lg w-100 py-3 "
                style={{fontSize: '16px'}}
                onClick={() => navigate(MEDITATION_DASHBOARD) }
              >
                Medication Dashboard
              </button>
            </div>
          </div>
        </div>
      );
}

export default Meditation
